import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';
import Inputmask from 'inputmask';

const CNPJ_ALPHANUMERIC_MASK = 'AA.AAA.AAA/AAAA-99';

const CNPJ_ALPHANUMERIC_DEFINITIONS = {
  A: {
    validator: '[A-Za-z0-9]',
    casing: 'upper' as const,
  },
};

@Directive({
  selector: '[pdsMask]',
  standalone: false,
})
export class MaskDirective implements AfterViewInit {
  @Input('pdsMask')
  mask: string;

  @Input()
  alias: boolean;

  constructor(private elementRef: ElementRef) {
    this.mask = '';
    this.alias = false;
  }

  ngAfterViewInit() {
    if (this.alias) {
      Inputmask({ alias: this.mask }).mask(this.elementRef.nativeElement);
      return;
    }

    if (this.mask === '99.999.999/9999-99') {
      Inputmask({
        mask: CNPJ_ALPHANUMERIC_MASK,
        definitions: CNPJ_ALPHANUMERIC_DEFINITIONS,
      }).mask(this.elementRef.nativeElement);
      return;
    }

    Inputmask({ mask: this.mask }).mask(this.elementRef.nativeElement);
  }
}
